<template>
	<div id="appbox">
		<div class="top_heard">
				<div class="top_box" v-if="screenWidth>785">
					<div class="logo_box"  @click="gohome()">
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
				
					<div class="top_search_box" v-if="screenWidth>785" >
						<div class="top_search">
							<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
							  <el-option
							    v-for="item in options"
							    :key="item.value"
							    :label="item.label"
							    :value="item.value"
								
								>
							  </el-option>
							</el-select>
							<!-- <i class="el-icon-search"></i> -->
							<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
							<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="gotopsearch()" alt="" srcset="">
						</div>
						  
					</div>
				
				</div>
				<div class="top_tab_box">
					<van-nav-bar title="" style="color: #ffffff ;font-weight: 600;" @click-right="vannavshow=true" v-if="screenWidth<785" >
						<template #left>
							<div class="vannav_title" style="color: #217495;font-size: 16px;" >
								公告详情
							</div>
						</template>
						<template #title>
							<div class="vannav_title" style="width: 180px;padding: 20px;">
									<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
							</div>
						</template>
					  <template #right>
						  <van-icon name="ellipsis"  size="20"    />
					  </template>
					</van-nav-bar>
					<van-popup v-model="vannavshow"  :style="{ height: '50%' }" position="top">
						<van-picker
						  title=""
						  show-toolbar
						  :columns="vannavlist"
						  confirm-button-text="进入"
						  @confirm="vanlinkgo"
						  @cancel="vannavmenushow"
						  @change="onChange"
						/>
					</van-popup>
					<div class="toptabnav" v-if="screenWidth>785">
							<el-menu
							  :default-active="activeIndex2"
							  class="el-menu-demo"
							  mode="horizontal"
							  @select="handleSelect"
							  router
							  background-color="#FE7C2B"
							  text-color="#FFFFFF"
							  active-text-color="#FFFFFF">
							<el-menu-item index="/Home">首页</el-menu-item>
							<el-menu-item index="/Newslist" >研学新闻</el-menu-item>
							<el-menu-item index="/Courselist" >研学课程</el-menu-item>
							<el-submenu index="/institution">
							    <template slot="title">研学机构</template>
							    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
							    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
								<el-menu-item index="/traveler" >会员单位</el-menu-item> 
							  </el-submenu>
							
							<el-menu-item index="/Campmap" >研学地图</el-menu-item>
							<el-menu-item index="/Activitylist">活动中心</el-menu-item>
							<el-menu-item index="/Linelist" >研学线路</el-menu-item>
							<el-submenu index="/yanxueteam">
							    <template slot="title">研学团队</template>
							    <el-menu-item index="/mentorlist" >研学导师</el-menu-item>
							    <el-menu-item index="/expertlist" >专家团队</el-menu-item>
							  </el-submenu>
							<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
						</el-menu>
					</div>
				</div>
			</div>
		
		<div class="main_box" :style="screenWidth>785?'':'width:100%;'">
			<div class="newslist_box" :style="screenWidth>785?'':'width:100%;    flex-direction: column;'">
				<div class="newslist" :style="screenWidth>785?'':'width:100%; margin:0px;'">
			<!-- 		<div class="video_box" v-if="newsdata.vdo != ''">
						<video :src="newsdata.vdo" controls type="video/mp4"></video>
					</div> -->
					<div class="newsdatas" :style="screenWidth>785?'':'padding:15px;'">
						<div class="newstitle">
							{{newsdata.title}}
						</div>
						<div class="newsmsg2" :style="screenWidth>785?'':'padding:15px;'">
						<!-- 	<div class="date">
								{{newsdata.create_time}}
							</div> -->
							<div class="author">
								来源：{{newsdata.author||'公告'}}
							</div>
						<!-- 	<div class="">
								浏览数：{{newsdata.looks||''}}
							</div> -->
						</div>
						<div class="richbox" v-html="newsdata.content" >
						</div>
					</div>
				</div>
				<div class="quicknewslist" v-if="screenWidth>785">
					<div class="quick_title">
						最新公告
					</div>
					<div class="quicknews"   >
						<div class="quick_items"   v-for="(item, index) in quicklist" :key="item"  @click="detail(item.id)" @mouseenter="onitemopen(index)" >
							<i class="el-icon-question" v-if="index!=newsiconon" style="color: #ddd;"></i>
							<i class="el-icon-warning-outline" v-if="index==newsiconon" style="color: #FE7C2B;"></i>
							<!-- <img :src="item.icon" v-if="index==newsiconon" alt="" srcset=""> -->
							<div :class="index==newsiconon?'quick_text2':'quick_text'"   :style="index==newsiconon?'-webkit-box-orient:vertical;':''" >
								{{item.title}}
							</div>
						</div>
					</div>
				</div>
			</div>
			
			
		</div>
	<!-- 	<div class="swim_box">
			<div class="swim_title">
				小程序查看
			</div>
			<div class="swim_code">
				<img :src="newsdata.sun_code" alt="" srcset="">
			</div>
		</div> -->
		<div :class="tops?'navbar':'navbar-top'" v-if="screenWidth>785">
		     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
								<div style="font-size: 14px;">首页</div></a>
		     </el-tooltip>
		     <div  class="qrShow3 right2"   v-if="showofficialQR">
					<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				
				<div  class="qrShow2 right2" v-if="showserviceQR">
					<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
							
				    <div style="font-size: 14px;">客服</div></a>
		     <div  class="qrShow right" v-if="showQR">
							<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		    
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div>
		<!-- footer -->
		<div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;padding-top:20px;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="item in bottomnav" :key="item" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="item in bottomnav" :key="item" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
			<div class="row" :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'" >
				<!-- <div class="copy-left">
					<p><i class="el-icon-phone-outline"></i>{{pcsetdata.phone}}</p>
					<p><i class="el-icon-message"></i>{{pcsetdata.email}}</p>
					<p style="font-size: 13px;">地址信息：{{pcsetdata.address}}</p>
				</div> -->
				
				<div class="copy-left " :style="screenWidth>785?'':'width:40%;'" >
					<div class="bottom_logo"  v-if="screenWidth>785" >
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					
				</div>
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'" abort="">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import {  getNt, getCategory, getPc,getbottomnav } from '@/request/api'
	
	export default {
	  name: "newslist",
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
			  bottomnav:[],
			  //搜索相关
				top_search_url:'/Siteall',
				options: [
				{
					value: '/Siteall',
					label: '全站搜索'
				},{
				  value: '/Camplist',
				  label: '营地搜索'
				}, {
				  value: '/Baselist',
				  label: '基地搜索'
				}, {
				  value: '/Courselist',
				  label: '课程搜索'
				},{
				  value: '/Newslist',
				  label: '新闻搜索'
				},
				{
				  value: '/Activitylist',
				  label: '活动搜索'
				},
				{
				  value: '/Linelist',
				  label: '线路搜索'
				},
				{
				  value: '/mentorlist',
				  label: '导师搜索'
				},],
				//搜索相关
				manage_url:'/',
				manageoptions:[
					{
					  value: '/',
					  label: '管理入口'
					}, {
					  value: 'https://yxwy.wanjiaxiao.cn/',
					  label: '机构管理后台'
					},
					 {
						value:'http://xh.wanjiaxiao.cn/seeyon/index.jsp',
						 label: '研学OA平台'
					 }
				],
				activeIndex2: '/Newslist',
				phoneboxshow:false,
				userInfo: {
				  username: "",
				  education_name: "",
				  role_level: ""
				},
				logintype:true,
				banner:[
				],
				types:[],
				newslist:[],
				quicklist:[],
				aclist:[],
				newsiconon:'',
				category_id:'',
				total:0,
				page_index:1,
				uuid:'',
				newsdata:{},
				pcsetdata:{},
				showQR:false,
			 showserviceQR:false,
			  showofficialQR:false,
				tops:false,
				heights:window.innerHeight,
				scrolltop:'',
				//屏幕宽高
				// 屏幕宽度
				screenWidth: window.innerWidth,
				top_bannerWidth:Math.round(window.innerWidth/3.42),
				// 屏幕高度
				screenHeight: window.innerHeight,
				//手机端导航栏
				vannavshow:false,
				
				vannavlist:[
					{
						link:'/Home',
						text:'研学首页'
					},
					{
						link:'/Camplist',
						text:'营地列表'
					},
					{
						link:'/Newslist',
						text:'新闻资讯'
					},
					{
						link:'/Baselist',
						text:'基地列表'
					},
					{
						link:'/Courselist',
						text:'研学课程'
					},
					{
						link:'/Activitylist',
						text:'研学活动'
					},
					{
						link:'/Linelist',
						text:'研学线路'
					},
					
					{
						link:'/mentorlist',
						text:'研学导师'
					},
					{
						link:'/expertlist',
						text:'专家团队'
					},
				],
		      }
	  },
	  beforeCreate(){
	  	   const loading = this.$loading({
	  	            lock: true,
	  	            text: '页面载入……',
	  	            // spinner: 'el-icon-loading',
	  	            background: '#ffffff'
	  	          });
	  },
	  created() {
		   this.getpcset()
	  },
	  mounted() {
		   const { id } = this.$route.query;
		     window.addEventListener('resize', this.handleResize, true)
		   this.uuid = id
		   var token = localStorage.getItem('token')||''
		   this.token=token
		   this.getbottomnav()
		   this.getDetails()
		this.getQuicklist()
		
	  window.addEventListener('scroll', this.scrollToTop)
	  		
	  },
	   destroyed () {
	          window.removeEventListener('scroll', this.scrollToTop)
	    },
	  // 销毁监听
	  		beforeDestroy() {
	  		  window.removeEventListener('resize', this.handleResize);
	  		},
	  methods: {
		  gotopsearch(){
		  		  this.$router.push({
		  		    path: this.top_search_url,
		  		    name: this.top_search_url,
		  		    query: {
		  		      stitle: this.stitle,
		  		    }
		  		  }); 
		  },
		  manageurl(e){
		  		  console.log('Site',e)
		  		  if(e!='/'){
		  			   window.open(e) 
		  		  }
		  		this.manage_url='/'
		  		  // window.location.href = e;
		  		  
		  },
	  		  vanlinkgo(e){
	  		  		  console.log(e)
	  		  		  this.$router.push({
	  		  		    path: e.link,
	  		  		    name: e.link,
	  		  		    query: {
	  		  		    }
	  		  		  }); 
	  		  },
	  		  vannavmenushow(){
	  		  		this.vannavshow=false  
	  		  },
	  		  handleResize() {
	  		  		   this.top_bannerWidth = 0;
	  		    this.screenWidth = window.innerWidth;
	  		  		this.top_bannerWidth=window.innerWidth/3.42
	  		  		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
	  		    this.screenHeight = window.innerHeight;
	  		  },
		  getbottomnav(){
		  		  var data={
		  			  page_index:1,
		  			  page_size:15,
						flag:99
		  		  }
		  		getbottomnav(data).then(res=>{
		  			this.bottomnav=res.data.data.list
		  		})  
		  },
		  gobottomnav(type,link){
		  		  if(type==1){
		  			  this.$router.push({
		  			  	path:link
		  			  });
		  		  }else if(type==2){
			  window.location.href = link;
		  }
		  },
		  logout(){
		  			  var that=this
		  			  this.$confirm('是否确认退出登录?', '提示', {
		  			  					confirmButtonText: '确定',
		  			  					cancelButtonText: '取消',
		  			  					type: 'warning'
		  			  }).then(() => {
		  						this.$alert("已退出登录", '', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								localStorage.setItem('token', '')
		  								localStorage.setItem('refreshToken', '')
		  								 that.$router.go(0)
		  							}
		  						  });
		  			  }).catch(() => {
		  			  		 
		  			  });
		  },
		  showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
		  			  this.showserviceQR=true
		  },
		  hideserviceQRCode(){//隐藏二维码
		      this.showserviceQR = false
		  },
		  showQRCode(){//显示二维码
		          this.showQR = true
		      },
		      hideQRCode(){//隐藏二维码
		          this.showQR = false
		      },
		      scrollToTop () {
		          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		          this.scrolltop = scrollTop
		          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
		              this.tops = true
		          } else {
		              this.tops = false
		          }
		      },
		      gotop () {
		          let timer = setInterval(() => {
		              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
		              if (this.scrolltop === 0) {
		                  clearInterval(timer)
		              }
		          }, 15)
		      },
		  showphonebox(){
		  		this.phoneboxshow=true  
		  },
		  closephonebox(){
		  		this.phoneboxshow=false  
		  },
		  goregister(e){
		  			  this.$router.push({
		  			    path: "/register",
		  			    name: "/register",
		  			  		  query: {
		  			  		  }
		  			  });
		  },
		  gohome(e) {
		    this.$router.push({
		      path: "/Home",
		      name: "/Home",
		  			  query: {
		  			  }
		    });
		  },
	  		  getpcset(){
				var data={
				flag:99
			}
	  		  		getPc(data).then(res=>{
	  		  			this.pcsetdata=res.data.data
	  		  		})  
	  		  },
		  getDetails(){
			var data={
				uuid:this.uuid,
				flag:99
			}  
			getNt(data).then(res=>{
			  			  console.log(res.data)
						  this.newsdata=res.data.data
						  const loading = this.$loading({
						           lock: true,
						           text: 'Loading',
						           spinner: 'el-icon-loading',
						           background: 'rgba(0, 0, 0, 0.7)'
						         });
						  loading.close();
						  // this.quicklist=res.data.data.list
			  }).catch(error => {
				  console.error(error);
			});
		  },
		  handleClick(e){
				console.log(e,this.category_id)
				 this._getNewslist()
		  },
		  onitemopen(index){
			  this.newsiconon=index
		  },
		  gettypes(){
			  var data={}
			  getCategory(data).then(res=>{
			    			  console.log(res.data)
			    			  this.types=res.data.data
							  this.category_id=res.data.data[0].id
							  this._getNewslist()
			    }).catch(error => {
			    			  console.error(error);
			    			});
		  },
		getQuicklist(){
			var data={
				  page_index:1,
				  page_size:10,
				  flag:99
			  }
			getNt(data).then(res=>{
			  			  console.log(res.data)
						  this.quicklist=res.data.data
			  }).catch(error => {
			  			  console.error(error);
			  			});
		},
		  _getNewslist(){
			  var data={
				  page_index:this.page_index,
				  page_size:10,
				  category_id:this.category_id,
			  }
			getNewslist(data).then(res=>{
			  			  console.log(res.data)
			  			  this.newslist=res.data.data.list
						  this.total=res.data.data.total
			  }).catch(error => {
			  			  console.error(error);
			  			});
		  },
		
		   handleSelect(key, keyPath) {
		          console.log(key, keyPath);
		        },
	    /*
	     * 查看详情
	     * */
	    detail(e) {
			this.uuid=e
			this.getDetails()
			this.getQuicklist()
	      // this.$router.push({
	      //   path: "/NewsDetails",
	      //   name: "NewsDetails",
	      //   query: {
	      //     id: e
	      //   }
	      // });
	    },
	  }
	};
</script>
<style scoped>
	.richbox{
		text-align: left;
		font-size: 16px;
	}
	.main_box{
		width: 1100px;
		min-height: 600px;
		margin: 0 auto;
	}
	.video_box{
		padding: 30px;
	}
	.video_box video{
		width: 100%;
	}
	.newsdatas{
		padding: 30px;
	}
	.newslist_box{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.newslist{
		width: 790px;
		background: #fff;
		margin: 20px;
		margin-left: 0px;
	}
	.newsitem{
		width:720px ;
		margin: 0px  10px;
		padding: 20px 0px;
		border-bottom: 1px dashed #dadada;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.newsimg{
		width: 280px;
		height: 180px;
		margin-right:20px ;
	}
	.newsimg img{
		width: 100%;
		height: 100%;
	}
	.newsmsg2{
		margin-top: 34px;
		    padding-bottom: 6px;
		    color: #999;
		    font-size: 14px;
		    height: 22px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			 border-bottom: 1px dashed #999;

	}
	::v-deep img{
	     max-width:100%;
	 }
	.newstitle{
		color: #333;
	    font-weight: 400;
	    font-size: 24px;
	    text-align: center;
	}
	.date{
		margin-right: 30px;
	}
	.newsmsg2 .author{
		display: inline-block;
		max-width: 320px;
		overflow: hidden;
		text-overflow: ellipsis;
		vertical-align: text-bottom;
		white-space: nowrap;
	}
	
	.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
		color: #FE7C2B;
	}
	.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover{
		color: #FE7C2B;
	}
	.el-tabs__item{
		font-size: 18px;
		height: 60px;
		line-height: 60px;
		/* padding:30px ; */
	}
	.el-tabs--border-card .el-tabs__header{
		background-color: #ffffff;
	}
	.news_bottom{
		    font-size: 14px;
		    color: #999;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.pages_total{
		padding: 20px;
		padding-bottom: 0px;
		
	}
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #FE7C2B;
	}
	
	/* 快速新闻内容 */
	.quicknewslist{
		width: 395px;
		background-color: #ffffff;
		margin-top: 20px;
		border: 1px solid #DCDFE6;
		box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
	}
	.quick_title{
		    padding: 20px  0px;
		    background: #fff;
		    border-bottom: 2px solid #f8f8f8;
			font-size: 20px;
			color: #333;
			font-weight: 400;
	}
	.quicknews{
		padding: 20px;
	}
	.quick_items{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin: 20px 0px;
		
	}
	.quick_items i{
		margin-right: 10px;
	}
	.quick_items img{
		width: 120px;
		height: 77px;
		/* margin-left: 10px; */
		margin-right: 10px;
		background-color: #333;
	}
	.quick_text{
		    /* width: 100%; */
		color: #333;
		    font-size: 16px;
		    font-weight: 400;
		    line-height: 2;
		    overflow: hidden;
		    text-overflow: ellipsis;
		    white-space: nowrap;
			text-align: left;
	}
	.quick_text2{
		/* color: #333; */
		width: 310px;
		font-size: 16px;
		font-weight: 400;
		color: #FE7C2B;
		white-space: normal;
		/* line-height: 2; */
/* 		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap; */
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		display: -webkit-box;
		-webkit-line-clamp:2;
		-webkit-box-orient:vertical;
		overflow: hidden;

	}
</style>
<style>
</style>